import { Component, Inject, Input } from '@angular/core';

import { ConfirmationService, Footer } from 'primeng/api';

import { AuthService } from '../../service';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonDirective } from 'primeng/button';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'session-timeout-component',
  templateUrl: './session-timeout.component.html',
  providers: [ConfirmationService],
  imports: [DialogModule, ProgressBarModule, ButtonDirective]
})
export class SessionTimeoutComponent {

  @Input() countMinutes: number;
  @Input() countSeconds: number;
  @Input() progressCount: number;
  @Input() showTimeoutWarning: boolean;

  constructor(@Inject(AuthService) public authService: AuthService) { }

  continue() {
    if (!this.authService.isAuthenticated()) { this.authService.logout(); }
    this.showTimeoutWarning = false;
  }
  logout() {
    this.authService.logout();
    this.showTimeoutWarning = false;
  }
}
